import { render, staticRenderFns } from "./shuaOrder.vue?vue&type=template&id=ded2c4b8&scoped=true&"
import script from "./shuaOrder.vue?vue&type=script&lang=js&"
export * from "./shuaOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2c4b8",
  null
  
)

export default component.exports